export function getFollowerCount(user?: {
  followers_count?: number | null
  followers?: unknown[] | null
} | null): number {
  if (typeof user?.followers_count === 'number') return user.followers_count
  return Array.isArray(user?.followers) ? user.followers.length : 0
}
